var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"inline-flex items-center space-x-2",attrs:{"type":"button"},on:{"click":_vm.logout}},[_c('span',{staticClass:"hidden sm:inline"},[_vm._v("Logout")]),_c('LogoutIcon',{staticClass:"w-6 h-6 text-white"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }